import {
  MappedClass,
  MappedProperty,
  MappedPropertyArray,
  MappedPropertyClass,
  MappedPropertyDate,
} from '@h5s/util-object';
import { DateTime } from 'luxon';
import { Customer, CustomerData } from '../../profile-registry/entities';

import { ResourceValidationResult } from '../../shared/entities';
import { IstatCustomerMode } from './istat-customer-mode';
import { IstatSendStatus } from './istat-send-status';
import { IstatStatus } from './istat-status';
import { IstatMode } from './istat-mode';
import { PurchasedStayToCustomer } from '../../reservation/entities';

@MappedClass()
export class IstatCustomer {
  @MappedProperty({ toDto: 'EInvoicingCode' })
  EInvoicingCode: string | null;

  @MappedPropertyDate()
  birthDate: DateTime | null = null;

  @MappedProperty()
  birthDistrict: string | null;

  @MappedProperty()
  birthPlace: string | null;

  @MappedProperty()
  birthPlaceId: number | null;

  @MappedProperty()
  birthStateId: number | null;

  @MappedProperty()
  creditCardId: number | null;

  @MappedProperty()
  customerCode: string | null;

  @MappedPropertyClass(() => CustomerData)
  customerData: CustomerData;

  @MappedProperty(undefined, true)
  customerDataId: number | null;

  @MappedPropertyDate()
  documentDeadlineDate: DateTime | null;

  @MappedProperty()
  documentNumber: string | null;

  @MappedPropertyDate()
  documentReleaseDate: DateTime | null;

  @MappedProperty()
  documentReleaser: string | null;

  @MappedProperty()
  documentReleaserCityId: number | null;

  @MappedProperty()
  documentReleaserState: boolean;

  @MappedProperty()
  documentReleaserStateId: number | null;

  @MappedProperty()
  fiscalCode: string | null;

  @MappedProperty()
  id: string;

  @MappedProperty()
  involvedPurchasedStayIds: number[];

  @MappedProperty()
  customerId: number;

  // Queste proprietà sono convertiti in string
  @MappedProperty()
  istatCustomerMode: IstatCustomerMode;

  @MappedProperty()
  istatMode: IstatMode;

  @MappedProperty()
  istatSendStatus: IstatSendStatus;

  @MappedProperty()
  istatStatus: IstatStatus;

  @MappedProperty()
  leader: boolean;

  @MappedProperty()
  lotteryCode: string | null;

  @MappedProperty()
  message: string | null;

  @MappedProperty()
  middleName: string | null;

  @MappedProperty()
  multidbDocumentTypeId: number | null;

  @MappedProperty()
  name: string | null;

  @MappedProperty()
  nationalityId: number | null;

  @MappedProperty()
  password: string | null;

  @MappedProperty()
  pec: string | null;

  @MappedProperty()
  purchasedStayToCustomer: PurchasedStayToCustomer;

  @MappedProperty()
  relativePurchasedStayToCustomers: PurchasedStayToCustomer[];

  @MappedProperty()
  reservationId: number | null;

  @MappedPropertyArray(() => Customer)
  relatives: Customer[];

  @MappedProperty()
  room: string;

  @MappedProperty()
  sex: boolean;

  @MappedProperty()
  stateId: number | null;

  @MappedProperty()
  surname: string;

  @MappedProperty()
  takenRooms: number | null;

  @MappedPropertyArray(() => ResourceValidationResult)
  validationResults: ResourceValidationResult<Customer>[];

  @MappedProperty()
  vatCountryCode: string | null;

  @MappedProperty()
  vatNumber: string | null;

  constructor(init?: Partial<IstatCustomer>) {
    Object.assign(this, init);
  }

  public getDisplayName(): string {
    return [this.surname, this.name].join(' ');
  }

  /**
   * Verifica che l'IstatCustomer sia valido.
   * E' valido se validationResults non ha elementi e quindi non ci sono errori
   */
  public get isValid(): boolean {
    return this.validationResults.length === 0;
  }
}
